import { z } from "zod";

export const rerunAutomations = {
  input: z.object({ fulfillmentGroupIds: z.array(z.string()).nullish() }),
  output: z.object({ success: z.boolean(), error: z.string().nullish() }),
};
